import { ButtonERP, PrimeReactModal } from "@finanedi.es/storybook"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { MODAL_STYLES } from "constants/primereactStyles"
import { DefaultTFuncReturn } from "i18next"
import { useTranslation } from "react-i18next"

export interface ModalConfirmDeleteProps {
  isLoading?: boolean
  isOpen: boolean
  onCancel: () => void
  onConfirm: () => void
  paragraph?: DefaultTFuncReturn
  title?: DefaultTFuncReturn
}

export const ModalConfirmDelete = ({
  isLoading,
  isOpen = false,
  onCancel,
  onConfirm,
  paragraph,
  title,
}: ModalConfirmDeleteProps) => {
  const { t } = useTranslation()
  return (
    <PrimeReactModal
      visible={isOpen}
      className='tw-w-80 tw-rounded-lg tw-py-6 tw-px-6 tw-bg-white'
      baseZIndex={40}
      ptContext={MODAL_STYLES}
      closable={false}
      footer={
        <div
          key='Continue'
          className='tw-flex tw-items-center tw-justify-center tw-pb-1 tw-gap-4'
        >
          <ButtonERP
            label={`${t("bancos.cardsTable.deleteModal.cancelButton")}`}
            customize={{
              type: "white",
              size: "md",
            }}
            data-isloading={isLoading}
            onClick={onCancel}
          />
          <ButtonERP
            label={`${t("bancos.cardsTable.deleteModal.confirmButton")}`}
            customize={{
              type: "primary",
              size: "md",
            }}
            data-isloading={isLoading}
            onClick={onConfirm}
            loading={isLoading}
          />
        </div>
      }
    >
      <>
        <div className='tw-rounded-full tw-w-24 tw-h-24 tw-flex tw-justify-center tw-items-center tw-bg-simple-20 tw-mx-auto tw-mt-5 tw-mb-4'>
          <div className='tw-rounded-full tw-w-16 tw-h-16 tw-flex tw-justify-center tw-items-center tw-border tw-border-simple-90 tw-border-opacity-5 tw-bg-white tw-mx-auto'>
            <FontAwesomeIcon
              icon={["fal", "trash-alt"]}
              className='tw-w-8 tw-h-8 tw-text-danger'
            />
          </div>
        </div>
        {Boolean(title) && (
          <div className='tw-text-xl tw-font-medium tw-text-primary tw-text-center tw-mb-4'>
            {title}
          </div>
        )}
        {Boolean(paragraph) && (
          <div className='tw-w-full tw-flex tw-flex-col tw-text-center tw-px-4'>
            <p className='tw-mb-3 tw-text-lg'>{paragraph}</p>
          </div>
        )}
      </>
    </PrimeReactModal>
  )
}
